import {
    IonPage, IonContent, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import Script from "react-load-script";
import {captchaKeFuAppId, captchaUrl} from "../../../../utils/common";
import {FindPwdOps, modifyPassWord, SendSmsCodeSlider,ProtectUser} from "./Service";
import {PlatMd5} from "../../../../utils/platMd5";
import cookieUtil from "../../../../utils/cookieUtil";

class ChangePassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            newPassWord: '',
            agreementTip: true,
            scriptLoaded: false,
            showTipModal: false,
            getCodeMsg: "获取验证码",
            showGreyBackGround: false,
            showSetNewPW: false,
            oldPassWord: '',
            newPassWordOne: '',
            newPassWordTwo: '',
            isShowTip: false,
            showTipMsg: '',
            account: '',
            token: null,
        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[0-9]{6}$/)

    setPhone = (e) => {
        this.setState({phone: e, phoneTip: 0})
    }
    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")})
        } else {
            this.setState({
                isShowTip: true,
                showTipMsg: "非法进入，请走正常通道。"
            })
        }
    }
    checkPw = () => {
        const {newPassWordOne, newPassWordTwo} = this.state;
        if (!newPassWordOne === newPassWordTwo) {
            this.setState({
                isShowTip: true,
                showTipMsg: "两次新密码不一致，请重新输入。"
            })
        }
    };
    updatePassWord = () => {
        const {oldPassWord, newPassWordOne, newPassWordTwo, token} = this.state;
        if (newPassWordOne !== newPassWordTwo) {
            this.setState({
                isShowTip: true,
                showTipMsg: "两次输入的密码不一致，请重新输入"
            })
            return;
        }
        const params = {
            'oldPassword': PlatMd5.hashStr(oldPassWord).toUpperCase(),
            'newPassword': PlatMd5.hashStr(newPassWordOne).toUpperCase(),
            'confirmPassword': PlatMd5.hashStr(newPassWordTwo).toUpperCase(),
            'access_token': token,
            modifyPassType: 1,
        };
        modifyPassWord(params).then(ret => {
            if (ret.code === '10000') {
                console.log(ret.data);
                this.setState({
                    isShowTip: true,
                    showTipMsg: "修改成功"
                })
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                })
            }
        }).catch(err => {
            console.log(err);
        });
    };
    FindPwd = () => {
        const {code, account, newPassWordOne, newPassWordTwo} = this.state;
        if ("" === account) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入帐号'
            })
            return;
        }
        if (newPassWordOne !== newPassWordTwo) {
            this.setState({
                isShowTip: true,
                showTipMsg: "两次输入的密码不一致，请重新输入"
            })
            return;
        }
        const params = {
            'pwd': newPassWordOne,
            'confirmPwd': newPassWordTwo,
            'accounts': account,
            'smsCode': code,
        };
        FindPwdOps(params).then(ret => {
            if (ret.code === '10000') {
                this.setState({
                    isShowTip: true,
                    showTipMsg: "您的密码已修改成功，请重新登录客户端！"//修改这个文字时，请把本页面两处同时修改
                })
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                })
            }
        }).catch(err => {
            console.log(err);
        });
    }
    showView = (par) => {
        const {getCodeMsg, account} = this.state;
        if ("获取验证码" !== getCodeMsg) {
            return;
        }
        if ("" === account) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入帐号'
            })
            return;
        }
        const _that = this;
        // eslint-disable-next-line
        let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {
            if (res.ret === 0) {
                const urlParms = {
                    'ticket': res.ticket,
                    'randStr': res.randstr,
                    'sType': '3',
                    'accounts': account,
                }
                if (par === 'getUserInfo') {
                    ProtectUser(urlParms).then(ret => {
                        if (ret.code === '10000') {
                            console.log(ret.data);
                            if (ret.data.phone !==null&& ret.data.phone !=="") {
                                _that.setState({
                                    phone: ret.data.phone,
                                    showForgetPWTip: true,
                                    showGreyBackGround: true
                                })
                            } else {
                                _that.setState({
                                    isShowTip: true,
                                    showTipMsg: "该账号暂不支持此功能"
                                })
                            }
                        } else {
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: ret.msg
                            })
                        }
                        captcha1.destroy();
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });
                }
                else {
                    SendSmsCodeSlider(urlParms).then(ret => {
                        if (ret.code === '10000') {
                            captcha1.destroy();
                            //alert("验证码已发送，请注意查收")
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: "验证码已发送，请注意查收。"
                            })
                            let djs = 60;
                            let aa = '';
                            let timeout = setInterval(function () {
                                djs--;
                                aa = (djs === 0) ? '获取验证码' : (djs + 's');
                                if (djs === 0 || djs < 0) {
                                    clearInterval(timeout);
                                }
                                _that.setState({djs: djs, getCodeMsg: aa})
                            }, 999)
                        } else {
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: ret.msg
                            })
                            captcha1.destroy();
                        }
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });
                }
            }
        }, {bizState: 'RSCNO7XFNGG9r6xB'});
        captcha1.show(); // 显示验证码
    }
    setCode = (e) => {
        let codeTip = 0;
        if (this.regCode.test(e)) {
            codeTip = 1
        }
        this.setState({
            code: e,
            codeTip: codeTip
        })
    }
    showForgetPWAction=()=>{
        this.setState({
            showForgetPWAccount: true,
            showGreyBackGround: true
        })
    }
    nextStep = () => {
        const {codeTip} = this.state;
        if (codeTip !== 1) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入正确的短信验证码'
            })
            return
        }
        this.setState({
            showForgetPWTip: false,
            showSetNewPW: true
        })
    }

    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        if(this.state.showTipMsg==="您的密码已修改成功，请重新登录客户端！"){
            window.location.href = "/phone/index";
        }
        else{
            this.setState({
                isShowTip: false,
                showTipMsg: null
            })
        }
    }

    render() {
        const {phone, phoneTip, showForgetPWTip, showGreyBackGround, showSetNewPW, getCodeMsg,showForgetPWAccount} = this.state;
        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont bggray">
                        <div className={phoneTip === 1 ? "phone_top pr mb56" : "phone_top pr"}>
                            <div className="top_title">修改密码</div>
                        </div>
                        <div className="cont_kf">
                            <div className="phone_input_box pr">
                                <div className={phoneTip === 1 ? "point pa" : "point pa dn"}>
                                    <p>您输入的原始密码不正确，请核对后再尝试修改</p></div>
                                <div className="border-bottom"></div>
                                <div className="phone_identity clearfix">
                                    <span className="w168">旧密码</span>
                                    <input type="password" className="ipt input-tex4"
                                           onChange={e => this.setState({oldPassWord: e.target.value})}
                                           placeholder="输入您原来的密码"/>
                                </div>
                                <Script
                                    url={captchaUrl()}
                                    onError={this.handleScriptError}
                                    onLoad={this.handleScriptLoad}
                                />
                                <div className="phone_identity clearfix">
                                    <span className="w168">新密码</span>
                                    <input type="password" className="input-tex4" placeholder="输入新密码"
                                           onChange={e => this.setState({newPassWordOne: e.target.value})}/>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w168">确认新密码</span>
                                    <input type="password" className="input-tex4" placeholder="再次输入新密码"
                                           onChange={e => this.setState({newPassWordTwo: e.target.value})}
                                           onBlur={this.checkPw}/>
                                </div>
                                <div className="ts_tex"><span>温馨提醒：</span>1. 定期更换密码，可提高账号的安全<br/>
                                    2. 密码包含8-16个字符（字母、数字、特殊字符），<br/>且区分大小写
                                </div>
                                <a className="btn_kf mt100" onClick={this.updatePassWord}>确认</a>
                                <div className="Forgot_password" onClick={this.showForgetPWAction}>忘记密码？</div>
                            </div>
                            {/*<!-------------------------灰色透明层--------------------->*/}
                            <div className={showGreyBackGround ? "greybackground" : "dn"}></div>
                            {/*<!-------------------------忘记密码输入帐号 tc--------------------->*/}
                            <div className={showForgetPWAccount ? "tc02" : "dn"}>
                                <div className="tc_bg">
                                    <a className="close" onClick={() => this.setState({
                                        showGreyBackGround: false,
                                        showForgetPWAccount: false,
                                    })}>关闭</a>
                                    <div className="tc_cont pr">
                                        <div className="tc_title">找回登录密码</div>
                                        <div className="point2 pa dn"><p>请输入帐号</p></div>
                                        <div className="tc_cont_tex">
                                            <div className="tc_input clearfix">
                                                <div className="input_tex">帐号</div>
                                                <input type="text" className="input-tex2" placeholder="请输入帐号"
                                                       onChange={e => this.setState({account: e.target.value})}/>
                                            </div>
                                            <a className="btn_kf m50" onClick={()=>this.showView('getUserInfo')}>确认</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*<!-------------------------忘记密码 tc--------------------->*/}
                            <div className={showForgetPWTip ? "tc02" : "dn"}>
                                <div className="tc_bg">
                                    <a className="close" onClick={() => this.setState({
                                        showGreyBackGround: false,
                                        showForgetPWTip: false
                                    })}>关闭</a>
                                    <div className="tc_cont pr">
                                        <div className="tc_title">手机验证</div>
                                        <div className="point2 pa dn"><p>短信验证码不匹配</p></div>
                                        <div className="tc_cont_tex">
                                            <p>正在使用绑定手机<em>{phone}</em>找回密码</p>
                                            <Script
                                                url={captchaUrl()}
                                                onError={this.handleScriptError}
                                                onLoad={this.handleScriptLoad}
                                            />
                                            <div className="tc_input clearfix">
                                                <span>验证码</span>
                                                <input type="text" className="input-tex2"
                                                       onChange={e => this.setCode(e.target.value)}
                                                       placeholder="请输入验证码"/>
                                                <input type="button" onClick={() => this.showView('sendsms')}
                                                       className="input-button-kefu" value={getCodeMsg}/>
                                            </div>
                                            <a className="btn_kf m50" onClick={() => this.nextStep()}>下一步</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*<!-------------------------设置新的密码 tc--------------------->*/}
                            <div className={showSetNewPW ? "tc02" : "dn"}>
                                <div className="tc_bg">
                                    <a className="close" onClick={() => this.setState({
                                        showGreyBackGround: false,
                                        showSetNewPW: false,
                                    })}>关闭</a>
                                    <div className="tc_cont pr">
                                        <div className="tc_title">设置新密码</div>
                                        <div className="point2 pa dn"><p>两次输入的密码不不一致</p></div>
                                        <div className="tc_cont_tex">
                                            <p className="tac">请重新设置密码</p>
                                            <div className="tc_input clearfix">
                                                <div className="input_tex">新密码</div>
                                                <input type="password" className="input-tex2" placeholder="输入新密码"
                                                       onChange={e => this.setState({newPassWordOne: e.target.value})}/>
                                            </div>
                                            <div className="tc_input clearfix">
                                                <div className="input_tex">确认新密码</div>
                                                <input type="password" className="input-tex2"
                                                       placeholder="再次输入新密码"
                                                       onChange={e => this.setState({newPassWordTwo: e.target.value})}
                                                       onBlur={this.checkPw}/>
                                            </div>
                                            <a className="btn_kf m50" onClick={this.FindPwd}>确认</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(ChangePassword);
